import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { CreateDevice } from './components/Modalcreate'
import { useNavigate } from 'react-router-dom'
import { getDevices, getDevicesListglobal } from './request/request'
import { useAppSelector } from '../../../../redux/hooks'
import Swal from 'sweetalert2'
import { useAuth } from '../../auth'
import '../../../../app/styles/components/customTable.css'
import styles from '../statusGral/cloudStatusTable.module.scss'

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import ImportExportIcon from '@mui/icons-material/ImportExport'

const API_URL = process.env.REACT_APP_API_URL

type ID = undefined | null | number

function RegisterCTXCrud(props: any) {
    const { currentUser } = useAuth()
    const tenant = useAppSelector(state => state.TenantSlice.id)
    const Id = useAppSelector(state => state.SuscriptionSlice.id)
    const Type = useAppSelector(state => state.CloudSlice.Type)
    const nameregion = useAppSelector(state => state.RegionSlice.name)

    const navigate = useNavigate()

    const [records, setRecords] = useState<any[]>([])
    const [ID, setID] = useState<ID>(undefined)
    const [swalInput, setSwalInput] = useState('')

    // --- Estados para búsqueda/filtrado por columna ---
    const [searchTerm, setSearchTerm] = useState('')
    const [searchColumn, setSearchColumn] = useState('All')

    // --- Estados para ordenamiento ---
    const [sortColumn, setSortColumn] = useState<string>('')
    const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc')

    // --- Estados para paginación ---
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)

    // --------------------------------------------------------------------------
    // 1) Carga de datos
    // --------------------------------------------------------------------------
    useEffect(() => {
        if (currentUser?.ListPermiso?.includes('CTXR.List')) {
            // Lógica de carga según tenant/Id/Type no-Global
            if (tenant === 0 && Id && Type !== 'CloudGlobal') {
                getDevices(Id, Type, nameregion).then(response => {
                    setRecords(response.data)
                })
            } else if (tenant !== 0 && Id && Type !== 'CloudGlobal') {
                getDevicesListglobal(Id, tenant, Type, nameregion).then(response => {
                    setRecords(response.data)
                })
            } else if (tenant === 0 && Id === -1) {
                getDevices(-1).then(response => {
                    setRecords(response.data)
                })
            } else if (tenant !== 0 && Id === -1) {
                getDevicesListglobal(-1, tenant).then(response => {
                    setRecords(response.data)
                })
            }
        }
    }, [nameregion, Id])

    useEffect(() => {
        if (currentUser?.ListPermiso?.includes('CTXR.List')) {
            // Lógica de carga según tenant/Id/Type == CloudGlobal
            if (tenant === 0 && Id && Type === 'CloudGlobal') {
                getDevices(Id).then(response => {
                    setRecords(response.data)
                })
            } else if (tenant !== 0 && Id && Type === 'CloudGlobal') {
                getDevicesListglobal(Id, tenant).then(response => {
                    setRecords(response.data)
                })
            }
        }
    }, [Id, Type, props.num])

    useEffect(() => {
        if (Id) {
            setRecords([])
        }
    }, [Id])

    // --------------------------------------------------------------------------
    // 2) Funciones para ordenamiento
    // --------------------------------------------------------------------------
    const handleSort = (column: string) => {
        if (sortColumn === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
        } else {
            setSortColumn(column)
            setSortDirection('asc')
        }
    }

    const getSortIcon = (col: string) => {
        if (sortColumn === col) {
            return sortDirection === 'asc' ? (
                <KeyboardArrowUpIcon className={styles['sort-icon']} />
            ) : (
                <KeyboardArrowDownIcon className={styles['sort-icon']} />
            )
        } else {
            return (
                <ImportExportIcon
                    className={styles['sort-icon']}
                    style={{ opacity: 0.7 }}
                />
            )
        }
    }

    function applySort(data: any[]) {
        if (!sortColumn) return data
        const sorted = [...data].sort((a, b) => {
            const valA = getValueForSort(a, sortColumn)
            const valB = getValueForSort(b, sortColumn)
            if (typeof valA === 'string' && typeof valB === 'string') {
                if (valA < valB) return sortDirection === 'asc' ? -1 : 1
                if (valA > valB) return sortDirection === 'asc' ? 1 : -1
                return 0
            }
            return 0
        })
        return sorted
    }

    const getValueForSort = (item: any, column: string): string => {
        switch (column) {
            case 'name':
                return item.name?.toLowerCase() || ''
            case 'description':
                return item.description?.toLowerCase() || ''
            case 'license':
                return item.license?.toLowerCase() || ''
            case 'id':
                return item.id?.toLowerCase?.() || item.id?.toString()?.toLowerCase?.() || ''
            case 'cluster':
                // if we want to sort by cluster name
                return item.cluster?.name?.toLowerCase() || ''
            default:
                return ''
        }
    }

    // --------------------------------------------------------------------------
    // 3) Funciones para búsqueda / filtrado
    // --------------------------------------------------------------------------
    function applySearch(data: any[]) {
        if (!searchTerm) return data
        const lowerTerm = searchTerm.toLowerCase()
        return data.filter((d: any) => {
            if (searchColumn === 'All') {
                return (
                    d.name?.toLowerCase()?.includes(lowerTerm) ||
                    d.description?.toLowerCase()?.includes(lowerTerm) ||
                    d.license?.toLowerCase()?.includes(lowerTerm) ||
                    d.id?.toString()?.toLowerCase()?.includes(lowerTerm) ||
                    (d.cluster?.name?.toLowerCase() || '').includes(lowerTerm)
                )
            } else {
                // single-column filter
                let val = ''
                switch (searchColumn) {
                    case 'name':
                        val = d.name?.toLowerCase() || ''
                        break
                    case 'description':
                        val = d.description?.toLowerCase() || ''
                        break
                    case 'license':
                        val = d.license?.toLowerCase() || ''
                        break
                    case 'id':
                        val = d.id?.toString()?.toLowerCase() || ''
                        break
                    case 'cluster':
                        val = d.cluster?.name?.toLowerCase() || ''
                        break
                    default:
                        val = ''
                }
                return val.includes(lowerTerm)
            }
        })
    }

    // --------------------------------------------------------------------------
    // 4) Paginación + Filtros + Orden
    // --------------------------------------------------------------------------
    const filteredData = applySearch(records)
    const sortedData = applySort(filteredData)

    const totalItems = sortedData.length
    const totalPages = Math.ceil(totalItems / itemsPerPage)
    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    const paginatedData = sortedData.slice(startIndex, endIndex)

    const handleRecordsPerPageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setItemsPerPage(Number(e.target.value))
        setCurrentPage(1)
    }

    const handlePageChange = (page: number) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page)
        }
    }

    // --------------------------------------------------------------------------
    // 5) Lógica para Release license y Delete device
    // --------------------------------------------------------------------------
    function release(id: any) {
        Swal.fire({
            position: 'center',
            icon: 'warning',
            title: 'Are you sure?',
            text: 'Once deleted, you will not be able to recover this License!',
            inputLabel: 'Enter "confirm" to continue...',
            input: 'text',
            inputPlaceholder: 'confirm',
            inputValue: swalInput,
            showCancelButton: true,
            confirmButtonColor: '#00BCD1',
            cancelButtonColor: '#FF4089',
            confirmButtonText: 'Yes, delete it!',
            preConfirm: (value) => {
                if (!value.toLowerCase().includes('confirm')) {
                    Swal.showValidationMessage(
                        'Please write the word "confirm"  to continue.'
                    )
                } else {
                    setSwalInput(value)
                }
            }
        }).then(result => {
            if (result.isConfirmed) {
                setSwalInput('')
                if (tenant === 0 && Type !== 'Global') {
                    axios.delete(`${API_URL}/v1/ctxr/${Id}/RemoveLicense/${id}`)
                        .then(res => {
                            if (res.data.error) {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'The license cannot be removed because it is activated.'
                                })
                            } else {
                                Swal.fire(
                                    'Deleted!',
                                    'Your License has been deleted.',
                                    'success'
                                )
                            }
                            getDevices(Id).then(response => {
                                setRecords(response.data)
                            })
                        })
                } else if (tenant !== 0 && Type !== 'Global') {
                    axios.delete(`${API_URL}/v1/ctxr/${Id}/RemoveLicense/${id}?tenantId=${tenant}`)
                        .then(res => {
                            if (res.data.error) {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'The license cannot be removed because it is activated.'
                                })
                            } else {
                                Swal.fire(
                                    'Deleted!',
                                    'Your License has been deleted.',
                                    'success'
                                )
                            }
                            getDevicesListglobal(Id, tenant).then(response => {
                                setRecords(response.data)
                            })
                        })
                }
                if (tenant === 0 && Type === 'Global') {
                    axios.delete(`${API_URL}/v1/ctxr/${-1}/RemoveLicense/${id}`)
                        .then(res => {
                            if (res.data.error) {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'The License cannot be removed because it is activated.'
                                })
                            } else {
                                Swal.fire(
                                    'Deleted!',
                                    'Your License has been deleted.',
                                    'success'
                                )
                            }
                            getDevices(-1).then(response => {
                                setRecords(response.data)
                            })
                        })
                } else if (tenant !== 0 && Type === 'Global') {
                    axios.delete(`${API_URL}/v1/ctxr/${-1}/RemoveLicense/${id}?tenantId=${tenant}`)
                        .then(res => {
                            if (res.data.error === 'licencia esta activada') {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'The License cannot be removed because it is activated.'
                                })
                            } else {
                                Swal.fire(
                                    'Deleted!',
                                    'Your License has been deleted.',
                                    'success'
                                )
                            }
                            getDevicesListglobal(-1, tenant).then(response => {
                                setRecords(response.data)
                            })
                        })
                }
            } else {
                Swal.fire({ title: 'Your License is safe!', icon: 'success' })
            }
        })
    }

    function deletedevice(id: any) {
        Swal.fire({
            position: 'center',
            icon: 'warning',
            title: 'Are you sure?',
            text: 'Once deleted, you will not be able to recover this Instance!',
            inputLabel: 'Enter "confirm" to continue...',
            input: 'text',
            inputPlaceholder: 'confirm',
            inputValue: swalInput,
            showCancelButton: true,
            confirmButtonColor: '#00BCD1',
            cancelButtonColor: '#FF4089',
            confirmButtonText: 'Yes, delete it!',
            preConfirm: (value) => {
                if (!value.toLowerCase().includes('confirm')) {
                    Swal.showValidationMessage(
                        'Please write the word "confirm"  to continue.'
                    )
                } else {
                    setSwalInput(value)
                }
            }
        }).then(result => {
            if (result.isConfirmed) {
                setSwalInput('')
                if (tenant === 0 && Type !== 'Global') {
                    axios.delete(`${API_URL}/v1/ctxr/${Id}/${id}`)
                        .then(res => {
                            if (res.data.error && res.data.error !== 'device cluster not allowed to delete device') {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'The Instance cannot be removed because it is activated.'
                                })
                            } else if (res.data.error && res.data.error === 'device cluster not allowed to delete device') {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Your Instance belongs to a cluster, it cannot be deleted.'
                                })
                            } else {
                                Swal.fire(
                                    'Deleted!',
                                    'Your Instance has been deleted.',
                                    'success'
                                )
                            }
                            getDevices(Id).then(response => {
                                setRecords(response.data)
                            })
                        })
                } else if (tenant !== 0 && Type !== 'Global') {
                    axios.delete(`${API_URL}/v1/ctxr/${Id}/${id}?tenantId=${tenant}`)
                        .then(res => {
                            if (res.data.error && res.data.error !== 'device cluster not allowed to delete device') {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'The Instance cannot be removed because it is activated.'
                                })
                            } else if (res.data.error && res.data.error === 'device cluster not allowed to delete device') {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Your Instance belongs to a cluster, it cannot be deleted.'
                                })
                            } else {
                                Swal.fire(
                                    'Deleted!',
                                    'Your Instance has been deleted.',
                                    'success'
                                )
                            }
                            getDevicesListglobal(Id, tenant).then(response => {
                                setRecords(response.data)
                            })
                        })
                }
                if (tenant === 0 && Type === 'Global') {
                    axios.delete(`${API_URL}/v1/ctxr/${-1}/${id}`)
                        .then(res => {
                            if (res.data.error && res.data.error !== 'device cluster not allowed to delete device') {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'The Instance cannot be removed because it is activated.'
                                })
                            } else if (res.data.error && res.data.error === 'device cluster not allowed to delete device') {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Your Instance belongs to a cluster, it cannot be deleted.'
                                })
                            } else {
                                Swal.fire(
                                    'Deleted!',
                                    'Your Instance has been deleted.',
                                    'success'
                                )
                            }
                            getDevices(-1).then(response => {
                                setRecords(response.data)
                            })
                        })
                } else if (tenant !== 0 && Type === 'Global') {
                    axios.delete(`${API_URL}/v1/ctxr/${-1}/${id}?tenantId=${tenant}`)
                        .then(res => {
                            if (res.data.error && res.data.error === 'licencia esta activada') {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'The Instance cannot be removed because it is activated.'
                                })
                            } else if (res.data.error && res.data.error === 'device cluster not allowed to delete device') {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Your Instande belongs to a cluster, it cannot be deleted.'
                                })
                            } else {
                                Swal.fire(
                                    'Deleted!',
                                    'Your Instance has been deleted.',
                                    'success'
                                )
                            }
                            getDevicesListglobal(-1, tenant).then(response => {
                                setRecords(response.data)
                            })
                        })
                }
            } else {
                Swal.fire({ title: 'Your Instance is safe!', icon: 'success' })
            }
        })
    }

    return (
        <>
            <div className='card' style={{overflow:'visible'}}>
                <div className='card-body py-3' style={{ minHeight: '40vh' }}>
                    <div className='tab-content'>
                        <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                            {/* --- Barra de búsqueda / Filtros / Totales --- */}
                            {records.length > 0 && (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginBottom: '10px',
                                        marginRight: '5px',
                                    }}
                                >
                                    <div>
                                        <span className="text-marino f-parrafo fw-semibold">
                                            Total Records: {totalItems}
                                        </span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', height: '40px' }}>
                                        <div
                                            className="input-group custom-search-group"
                                            style={{ display: 'flex', height: '40px' }}
                                        >
                                            <span
                                                className="input-group-text"
                                                style={{
                                                    justifyContent: 'center',
                                                    height: '40px',
                                                    lineHeight: '40px',
                                                    padding: '0 8px'
                                                }}
                                            >
                                                <i
                                                    className="bi-search"
                                                    style={{ fontSize: '1rem', color: '#FF4089', verticalAlign: 'middle' }}
                                                ></i>
                                            </span>
                                            <select
                                                className="form-select"
                                                style={{
                                                    border: '1px solid var(--bs-gray-300)',
                                                    width: '185px',
                                                    height: '40px',
                                                    lineHeight: '40px',
                                                    padding: '0 8px',
                                                    fontSize: '0.875rem'
                                                }}
                                                value={searchColumn}
                                                onChange={(e) => {
                                                    setSearchColumn(e.target.value)
                                                    setCurrentPage(1)
                                                }}
                                            >
                                                <option value="All">All</option>
                                                <option value="name">Name</option>
                                                <option value="description">Description</option>
                                                <option value="license">License</option>
                                                <option value="id">ID</option>
                                                <option value="cluster">High Availability</option>
                                            </select>
                                            <input
                                                type="text"
                                                className="form-control"
                                                style={{
                                                    width: '150px',
                                                    height: '40px',
                                                    lineHeight: '40px',
                                                    padding: '0 8px',
                                                    fontSize: '0.875rem'
                                                }}
                                                placeholder={`Search by ${searchColumn === 'All' ? 'All' : searchColumn}`}
                                                value={searchTerm}
                                                onChange={(e) => {
                                                    setSearchTerm(e.target.value)
                                                    setCurrentPage(1)
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className='table-responsive' style={{overflow:'visible'}}>
                                {paginatedData.length === 0 ? (
                                    <>
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                height: '100px',
                                            }}
                                        >
                                            <span style={{
                                                color: '#FF4089',
                                                fontWeight: 'bold',
                                                fontSize: '1.5rem',
                                            }}>No Data Available</span>
                                        </div></>
                                ) : (
                                    <table className='w-full f-parrafo caption-bottom custom-table'>
                                        <thead>
                                            <tr className='text-azul'>
                                                <th
                                                    className='table-cell'
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleSort('name')}
                                                >
                                                    <div className={styles['header-content']}>
                                                        <span>Name</span>
                                                        <span className={styles['sortable-column']}>{getSortIcon('name')}</span>
                                                    </div>
                                                </th>
                                                <th
                                                    className='table-cell'
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleSort('description')}
                                                >
                                                    <div className={styles['header-content']}>
                                                        <span>Description</span>
                                                        <span className={styles['sortable-column']}>{getSortIcon('description')}</span>
                                                    </div>
                                                </th>
                                                <th
                                                    className='table-cell'
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleSort('license')}
                                                >
                                                    <div className={styles['header-content']}>
                                                        <span>License</span>
                                                        <span className={styles['sortable-column']}>{getSortIcon('license')}</span>
                                                    </div>
                                                </th>
                                                <th
                                                    className='table-cell'
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleSort('id')}
                                                >
                                                    <div className={styles['header-content']}>
                                                        <span>ID</span>
                                                        <span className={styles['sortable-column']}>{getSortIcon('id')}</span>
                                                    </div>
                                                </th>
                                                <th
                                                    className='table-cell'
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleSort('cluster')}
                                                >
                                                    <div className={styles['header-content']}>
                                                        <span>High Availability</span>
                                                        <span className={styles['sortable-column']}>{getSortIcon('cluster')}</span>
                                                    </div>
                                                </th>
                                                <th className='table-cell' style={{ width: '200px' }}>
                                                    Actions
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paginatedData.map((d: any, i: number) => (
                                                <tr key={i} className='table-row'>
                                                    <td className='table-cell'>{d.name}</td>
                                                    <td className='table-cell'>{d.description}</td>
                                                    <td className='table-cell'>{d.license}</td>
                                                    <td className='table-cell'>{d.id}</td>
                                                    <td className='table-cell table-cell-center'>
                                                        {d.cluster === null ? (
                                                            <span className='badge badge-light-danger'>Off</span>
                                                        ) : (
                                                            <span className='badge badge-light-primary'>{d.cluster.name}</span>
                                                        )}
                                                    </td>
                                                    <td
                                                        className="table-cell table-cell-center"
                                                    // Casting as any allows us to bypass TS checking of the !important syntax
                                                    >
                                                        <div className="btn-group" role="group">
                                                            <button
                                                                type="button"
                                                                className="btn-light-marino dropdown-toggle"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                            >
                                                                Actions
                                                            </button>
                                                            <ul className="dropdown-menu" style={{zIndex: 1050, position:'absolute'}}>
                                                                {currentUser?.ListPermiso?.includes('CTXR.Update') && (
                                                                    <li>
                                                                        <button
                                                                            className="btn dropdown-item-edit"
                                                                            type="button"
                                                                            onClick={() => setID(d.id)}
                                                                        >
                                                                            Edit Instance
                                                                        </button>
                                                                    </li>
                                                                )}
                                                                {currentUser?.ListPermiso?.includes('CTXR.Delete') && (
                                                                    <li>
                                                                        <button
                                                                            className="btn dropdown-item-release"
                                                                            type="button"
                                                                            onClick={(e) => release(d.id)}
                                                                        >
                                                                            Release License
                                                                        </button>
                                                                    </li>
                                                                )}
                                                                {currentUser?.ListPermiso?.includes('CTXR.Delete') && (
                                                                    <li>
                                                                        <button
                                                                            className="btn dropdown-item-delete"
                                                                            type="button"
                                                                            onClick={(e) => deletedevice(d.id)}
                                                                        >
                                                                            Delete Instance
                                                                        </button>
                                                                    </li>
                                                                )}
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>

                            {/* --- Paginación --- */}
                            {sortedData.length > 0 && (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginTop: '10px',
                                    }}
                                >
                                    <div>
                                        {currentPage > 1 && (
                                            <button
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                className='btn btn-secondary'
                                            >
                                                Previous
                                            </button>
                                        )}
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <span>
                                            Page {currentPage} of {totalPages}
                                        </span>
                                    </div>
                                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                        {currentPage < totalPages && (
                                            <button
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                className='btn btn-secondary'
                                            >
                                                Next
                                            </button>
                                        )}
                                        <div className='select-container'>
                                            <select
                                                className='custom-select aligned-select text-center'
                                                aria-label='Select items per page'
                                                value={itemsPerPage}
                                                onChange={handleRecordsPerPageChange}
                                                style={{ width: '90px' }}
                                            >
                                                <option value={5}>5 rows</option>
                                                <option value={10}>10 rows</option>
                                                <option value={20}>20 rows</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {ID !== undefined && <CreateDevice setID={setID} id={ID} setRecords={setRecords} />}
        </>
    )
}

export default RegisterCTXCrud
